// 2P AI — interruttore tema manuale (prevale sull'auto e si persiste). Vedi lib/theme.
import { useTheme } from '../lib/theme';
import { Icon } from './Icon';

export function ThemeToggle() {
  const [theme, toggle] = useTheme();
  return (
    <button className="iconbtn" type="button" onClick={toggle} title="Cambia tema" aria-label="Cambia tema">
      <Icon name={theme === 'dark' ? 'light_mode' : 'dark_mode'} />
    </button>
  );
}
